import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  ORGANISATIONS_QUERY_KEY,
  USER_PROFILE_QUERY_KEY,
} from 'constants/queryKeys';
import OrganisationsService from 'services/OrganisationsService';
import { ICreateOrganisationRequest } from 'interfaces/IOrganisations';

export const useCreateOrganisation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: ICreateOrganisationRequest) =>
      OrganisationsService.CreateOrganisation(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [ORGANISATIONS_QUERY_KEY] });
      queryClient.invalidateQueries({ queryKey: [USER_PROFILE_QUERY_KEY] });
    },
  });
};

export default useCreateOrganisation;
